import { render, staticRenderFns } from "./look-openid.vue?vue&type=template&id=4fbfb37e&scoped=true"
import script from "./look-openid.vue?vue&type=script&lang=js"
export * from "./look-openid.vue?vue&type=script&lang=js"
import style0 from "./look-openid.vue?vue&type=style&index=0&id=4fbfb37e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbfb37e",
  null
  
)

export default component.exports